import { memo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import useAuth from "../../hooks/useAuth";
import {
  getDefaultAuthorizedRoute,
  hasMenuPermission,
} from "../../utils/common";

const UnAuthGuard = ({ children }) => {
  const { isAuthenticated, user, accessType, isEmailVerified } = useAuth();
  const location = useLocation();
  // if (!isAuthenticated && user === null) {
  //   return <Navigate to="/login" />;
  // }

  if (isAuthenticated && accessType == 5 && user.isAccountOnboarding != 1) {
    return <Navigate to="/affiliate/payment-management" />;
  }

  if (isAuthenticated && user.subscriptionStatus == 0) {
    if (
      user.userType === 6 &&
      !hasMenuPermission(user, "my-subscription")
    ) {
      return <Navigate to={getDefaultAuthorizedRoute(user, accessType)} />;
    }

    if (accessType == 2 || accessType == 4) return <Navigate to="/plan-list" />;
    else if (accessType == 3) return <Navigate to="agency/plan-list" />;
  }

  if (isAuthenticated && user !== null) {
    return <Navigate to="/dashboard" />;
  } else if (
    location.pathname == "/reset-password" &&
    !localStorage.getItem("reset-verify-mail")
  ) {
    return <Navigate to="/" />;
  } else if (
    location.pathname == "/email-verification" &&
    !localStorage.getItem("email-verify") &&
    !!isEmailVerified
  ) {
    return <Navigate to="/" />;
  } else if (
    location.pathname == "/admin/reset-password" &&
    !localStorage.getItem("admin-reset-verify-mail")
  ) {
    return <Navigate to="/admin/login" />;
  }
  if (location.pathname != "/reset-password") {
    localStorage.removeItem("reset-verify-mail");
  }
  if (location.pathname != "/admin/reset-password") {
    localStorage.removeItem("admin-reset-verify-mail");
  }
  if (location.pathname != "/email-verification") {
    localStorage.removeItem("email-verify");
    localStorage.removeItem("action-type");
  }

  return <>{children}</>;
};

UnAuthGuard.propTypes = {
  children: PropTypes.node.isRequired,
};

export default memo(UnAuthGuard);
